(function () {
  var T = 100000; // R$ 1.000,00 em centavos
  var NOME = 'Bolsa Libert\u00e9';
  function fmt(c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function ensure() {
    document.querySelectorAll('shipping-bar').forEach(function (sb) {
      var n = sb.nextElementSibling;
      if (n && n.classList.contains('brinde-bar')) return;
      var d = document.createElement('div');
      d.className = (sb.className || '') + ' brinde-bar';
      d.innerHTML = sb.innerHTML;
      d.style.marginTop = '10px';
      d.style.display = 'block';
      sb.parentNode.insertBefore(d, sb.nextSibling);
    });
  }
  var of = window.fetch;
  function update() {
    ensure();
    of.call(window, '/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      c.items.forEach(function (i) { if (/bolsa libert/i.test(i.product_title)) c.total_price -= i.final_line_price; }); var falta = T - c.total_price;
      document.querySelectorAll('.brinde-bar').forEach(function (d) {
        d.style.display = c.item_count ? 'block' : 'none';
        var t = d.querySelector('.progress-bar__text');
        var p = d.querySelector('[data-progress-line]');
        if (t) t.innerHTML = falta > 0
          ? 'Faltam <strong>' + fmt(falta) + '</strong> para ganhar a ' + NOME + '!'
          : 'Parab\u00e9ns! Voc\u00ea ganhou a ' + NOME + '!';
        if (p) p.style.width = Math.min(100, Math.round(c.total_price / T * 100)) + '%';
      });
    }).catch(function () {});
  }
  window.fetch = function () {
    var u = arguments[0];
    u = typeof u === 'string' ? u : (u && u.url) || '';
    var pr = of.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(u)) {
      pr.then(function () { setTimeout(update, 400); });
    }
    return pr;
  };
  var tm;
  new MutationObserver(function () {
    var miss = false;
    document.querySelectorAll('shipping-bar').forEach(function (sb) {
      var n = sb.nextElementSibling;
      if (!n || !n.classList.contains('brinde-bar')) miss = true;
    });
    if (miss) { clearTimeout(tm); tm = setTimeout(update, 200); }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
